import { Media } from "chq";
import KEYS from "../constants";

const isMediaVideoType = (media: Blob) => (
  media instanceof File || media instanceof Blob)
  && media.type.startsWith(KEYS.VIDEO_TYPE);

export default isMediaVideoType;
